import { Card } from '@/components/ui/Card';
import { Table, THead, TBody, TR, TH, TD } from '@/components/ui/Table';
import { Chip } from '@/components/ui/Chip';
import { formatIDR, formatNumber } from '@/lib/format';
import type { CashierBreakdown } from '@/lib/api/reports';

export function CashierBreakdownTable({ cashiers }: { cashiers: CashierBreakdown[] }) {
  if (cashiers.length === 0) {
    return (
      <Card>
        <p className="text-small text-ink-subtle">Belum ada data kasir.</p>
      </Card>
    );
  }
  return (
    <Card padding="none">
      <div className="p-6 pb-4 border-b border-line">
        <h3 className="text-subhead font-display font-semibold text-ink">Performa kasir</h3>
        <p className="text-caption text-ink-subtle mt-1">
          Breakdown per kasir (jumlah transaksi &amp; total penjualan)
        </p>
      </div>
      <Table>
        <THead>
          <TR>
            <TH>Kasir</TH>
            <TH className="text-right">Transaksi</TH>
            <TH className="text-right">Total</TH>
            <TH className="text-right">Avg / transaksi</TH>
          </TR>
        </THead>
        <TBody>
          {cashiers.map((c, idx) => {
            const avg = c.count > 0 ? c.total / c.count : 0;
            return (
              <TR key={c.cashierId}>
                <TD>
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded-full bg-primary/10 text-primary flex items-center justify-center text-small font-medium">
                      {c.cashierName.charAt(0).toUpperCase()}
                    </div>
                    <span className="font-medium text-ink">{c.cashierName}</span>
                    {idx === 0 && <Chip variant="success">Top</Chip>}
                  </div>
                </TD>
                <TD className="text-right tabular-nums">{formatNumber(c.count)}</TD>
                <TD className="text-right tabular-nums font-medium">
                  {formatIDR(c.total)}
                </TD>
                <TD className="text-right tabular-nums text-ink-subtle">
                  {formatIDR(avg)}
                </TD>
              </TR>
            );
          })}
        </TBody>
      </Table>
    </Card>
  );
}
